import * as Mui from "@material-ui/core";

const List = Mui.styled(Mui.List)(({ theme }) => ({
  width: "100%"
}));

export default List;
